import Blue from "~/core";

new Blue({
  name: "Illegal Dumping Report List",
  selector: ".illegal-dumping-reports-table",
  setup(table) {
    table.querySelectorAll('.clickable-row').forEach(row => {
      row.addEventListener('keydown', (e) => {
        if (e.key === 'Enter') {
          row.click();
        }
      });
    });

    const reports = JSON.parse(table.dataset.reports);
    const pageSize = parseInt(table.dataset.pageSize);
    let currentPage = parseInt(table.dataset.currentPage);

    function renderPagination() {
      const pageNumbersTop = document.querySelector('.illegal-dumping-reports .pageNumbersTop');
      const pageNumbersBottom = document.querySelector('.illegal-dumping-reports .pageNumbersBottom');
      pageNumbersTop.innerHTML = '';
      pageNumbersBottom.innerHTML = '';

      const totalPages = Math.ceil(reports.length / pageSize);
      const pagesForPager = determinePagesForPager(currentPage, totalPages);

      const createPageButton = (page, isDisabled = false) => {
        const button = document.createElement('button');
        button.innerText = page;
        button.className = (page === currentPage) ? 'active' : '';
        button.classList.add('btn');
        if (isDisabled) {
          button.disabled = true;
        } else {
          button.onclick = () => goToPage(page);
        }
        return button;
      };

      // Always render first page button
      pageNumbersTop.appendChild(createPageButton(1));
      pageNumbersBottom.appendChild(createPageButton(1));

      // If total pages is greater than 5 and current page is greater than 3, render ellipsis
      if (totalPages > 5 && currentPage > 3) {
        const ellipsis = createPageButton('...', true);
        pageNumbersTop.appendChild(ellipsis);
        pageNumbersBottom.appendChild(ellipsis.cloneNode(true));
      }

      // Render buttons based on result of determinePagesForPager
      pagesForPager.forEach(page => {
        pageNumbersTop.appendChild(createPageButton(page));
        pageNumbersBottom.appendChild(createPageButton(page));
      });

      // If total pages is greater than 5 and current page is less than total pages - 2, render ellipsis
      if (totalPages > 5 && currentPage < totalPages - 2) {
        const ellipsis = createPageButton('...', true);
        pageNumbersTop.appendChild(ellipsis);
        pageNumbersBottom.appendChild(ellipsis.cloneNode(true));
      }

      // Always render last page button
      pageNumbersTop.appendChild(createPageButton(totalPages));
      pageNumbersBottom.appendChild(createPageButton(totalPages));
    }

    const MaximumNumberOfPagesForPager = 3;
    const DesiredRange = 3;

    function determinePagesForPager(currentPageNumber, totalPages) {
      let pagesForPager = [];
      let numberOfPagesInPager = 0;

      if (totalPages >= 3) {
        if (isNotFirstOrLastPage(currentPageNumber, totalPages)) {
          pagesForPager.push(currentPageNumber);
          numberOfPagesInPager++;
        }

        for (let i = 1; i <= DesiredRange; i++) {
          if (hasLessThanMaximumPagesInPager(numberOfPagesInPager)) {
            if (currentPageNumber - i > 1) {
              pagesForPager.push(currentPageNumber - i);
              numberOfPagesInPager++;
            }
          }

          if (hasLessThanMaximumPagesInPager(numberOfPagesInPager)) {
            if (currentPageNumber + i < totalPages) {
              pagesForPager.push(currentPageNumber + i);
              numberOfPagesInPager++;
            }
          }
        }
      }

      return pagesForPager.sort((a, b) => a - b);
    }

    function isNotLastPage(possiblePageNumber, totalPages) {
      return possiblePageNumber < totalPages;
    }

    function hasLessThanMaximumPagesInPager(numberOfPagesInPager) {
      return numberOfPagesInPager < MaximumNumberOfPagesForPager;
    }

    function isNotFirstOrLastPage(page, totalPages) {
      return isNotFirstPage(page) && isNotLastPage(page, totalPages);
    }

    function isNotFirstPage(page) {
      return page !== 1;
    }


    const renderTable = () => {
      const tableBody = table.querySelector('tbody');
      tableBody.innerHTML = '';

      const start = (currentPage - 1) * pageSize;
      const end = start + pageSize;
      const paginatedReports = reports.slice(start, end);

      paginatedReports.forEach(report => {
        const reportReviewLink = `${report.AdminUrlPrefix}/report-review?trackingId=${report.TrackingId}`;
        const trackingReportLink = `/track-reports?trackingId=${report.TrackingId}`;
        const reportLink = report.Status === "Action Taken. Report Closed" ? trackingReportLink : reportReviewLink;
        const row = `
            <tr class="clickable-row" tabindex="0" role="link" aria-label="Link to report ${report.TrackingId}" onclick="window.location.href='${reportLink}'">
              <td>${report.TrackingId}</td>
              <td>${report.DateSubmitted}</td>
              <td>${report.Jurisdiction}</td>
              <td>${report.Status}</td>
              <td>${report.Source}</td>
            </tr>
        `;
        tableBody.innerHTML += row;
      });

      if (Math.ceil(reports.length / pageSize) > 1) {
        renderPagination();
      }
    }

    const goToPage = (page) => {
      currentPage = page;
      table.dataset.currentPage = page;
      renderTable();
      document.querySelector('.illegal-dumping-reports').scrollIntoView({ behavior: 'smooth' });
    }

    const prevPage = () => {
      if (currentPage > 1) {
        goToPage(currentPage - 1);
      }
    }

    const nextPage = () => {
      const totalPages = Math.ceil(reports.length / pageSize);
      if (currentPage < totalPages) {
        goToPage(currentPage + 1);
      }
    }

    if (Math.ceil(reports.length / pageSize) > 1) {
      document.querySelector('.illegal-dumping-reports .prevPageTop').addEventListener('click', prevPage);
      document.querySelector('.illegal-dumping-reports .nextPageTop').addEventListener('click', nextPage);
      document.querySelector('.illegal-dumping-reports .prevPageBottom').addEventListener('click', prevPage);
      document.querySelector('.illegal-dumping-reports .nextPageBottom').addEventListener('click', nextPage);
    }
    else{
      // Hide pagination if there's only one page
      document.querySelectorAll('.illegal-dumping-reports .pagination').forEach(element => {
        element.style.display = 'none';
      });
    }

    renderTable();
  }
});